import { useEffect } from 'react';

import { PlayingState } from '@/scenarios/legacy-player/types/instance';

export const useForcePlayerPause = (
    pause: () => void,
    sessionStopped: boolean,
    playingState: PlayingState | undefined
) => {
    useEffect(() => {
        if (sessionStopped && playingState === PlayingState.play) {
            pause();
        }
    }, [playingState, pause, sessionStopped]);
};
